import GiftItemApi from '@apis/gift/GiftItemApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetGiftItemsParams } from '@models/gift';

const giftItemQueries = createQueryKeys('giftItem', {
    list: (giftCategoryId: string) => ({
        queryKey: ['giftItems', giftCategoryId],
        queryFn: () => GiftItemApi.getGiftItems({ giftCategoryId }),
    }),
    catalog: (params: GetGiftItemsParams) => ({
        queryKey: ['catalog', params],
        queryFn: () => GiftItemApi.getGiftItems(params),
    }),
    detail: (giftItemId: string) => ({
        queryKey: [giftItemId],
        queryFn: () => GiftItemApi.getGiftItem(giftItemId),
    }),
    nutritionFacts: (giftItemId: string) => ({
        queryKey: [giftItemId, 'nutritionFacts'],
        queryFn: () => GiftItemApi.getGiftItemNutritionFacts(giftItemId),
    }),
});

export default giftItemQueries;
